<app-leveltwo [pageName]="'New Construction Remodeling, Repair'">
<div class="General">

  <h3>{{'NewConstruction.PageTitle'|translate}}</h3>
  <p>{{'NewConstruction.Description'|translate}}</p>
  <h4>{{'NewConstruction.NewConst'|translate}}</h4>
  <p><b>{{'NewConstruction.UnderCali'|translate}}</b></p>
  <ul>
    <li>{{'NewConstruction.category1'|translate}}</li>
    <li>{{'NewConstruction.category2'|translate}}</li>
    <li>{{'NewConstruction.category3'|translate}}</li>
    <li>{{'NewConstruction.category4'|translate}}</li>
  </ul>

  <h4>{{'NewConstruction.NewAdditions'|translate}}</h4>
  <p>{{'NewConstruction.Worktoa'|translate}}</p>
  <p><b>{{'NewConstruction.Examples'|translate}}</b></p>
  <ul>
    <li>{{'NewConstruction.Examples1'|translate}}</li>
    <li>{{'NewConstruction.Examples2'|translate}}</li>
    <li>{{'NewConstruction.Examples3'|translate}}</li>
    <li>{{'NewConstruction.Examples4'|translate}}</li>
    <li>{{'NewConstruction.Examples5'|translate}}</li>
    <li>{{'NewConstruction.Examples6'|translate}}</li>
    <li>{{'NewConstruction.Examples7'|translate}}</li>
  </ul>

  <h4>{{'NewConstruction.RemodelingandRepair'|translate}}</h4>
  <p>{{'NewConstruction.Whatis'|translate}}</p>
  <p>{{'NewConstruction.Anyconstruction'|translate}}</p>

  <table>
    <tr>
      <th>{{'NewConstruction.Assessable'|translate}}</th>
      <th>{{'NewConstruction.NotAssessable'|translate}}</th>
    </tr>
    <tr>
      <td>{{'NewConstruction.Assessable1'|translate}}</td>
      <td>{{'NewConstruction.NotAssessable1'|translate}}</td>
    </tr>
    <tr>
      <td>{{'NewConstruction.Assessable2'|translate}}</td>
      <td>{{'NewConstruction.NotAssessable2'|translate}}</td>
    </tr>
    <tr>
      <td>{{'NewConstruction.Assessable3'|translate}}</td>
      <td>{{'NewConstruction.NotAssessable3'|translate}}</td>
    </tr>
    <tr>
      <td>{{'NewConstruction.Assessable4'|translate}}</td>
      <td>{{'NewConstruction.NotAssessable4'|translate}}</td>
    </tr>
    <!-- <tr>
      <td>{{'NewConstruction.Assessable5v3'|translate}}</td>

    </tr> -->
  </table>

  <br><br>

  <h4>{{'NewConstruction.Exclusions'|translate}}</h4>
  <p>{{'NewConstruction.Someconstruction'|translate}}</p>
  <p>{{'NewConstruction.Seeforms'|translate}}</p>

</div>
</app-leveltwo>
